define.alias("checkout/components/payment", "calendar/components/payment");